export default __webpack_public_path__ + "static/media/email.1d59ee10.png";